import { format } from 'date-fns';

export const $filters = {
  date(value) {
    if (!value) return '';
    var date = new Date(value);
    return format(date, 'dd/MM/yyyy');
  },
  datetime(value) {
    if (!value) return '';
    var date = new Date(value);
    return format(date, 'dd/MM/yyyy HH:mm:ss');
  },
};
